import { methodUploadPost } from './methods';
import { API_INFO } from '../constants';

export const handleCallExportFromDelvi = async (payload) => {
  const url = API_INFO + 'products/products/export-from-dilve/';
  return methodUploadPost(url, payload);
};
